<template>
    <div class="cc-product" :data-product-id="product.id" :data-product-attribute-id="product.id_attribute">
        <div class="cc-product__image">
            <a :href="product.link" :title="product.name" class="cc-product__image__link">
                <img :src="product.thumbnail" :alt="product.name" class="cc-product__image__thumbnail">
            </a>
        </div>
        <div class="cc-product__information">
            <div class="cc-product__information__header">
                <div class="cc-product__title" v-bind:class="{'cc-product__title--no-controls': !isEditable}">
                    <a :href="product.link" :title="product.name" class="cc-product__title__link">{{ product.name }}</a>
                </div>
                <div class="cc-product__controls" v-if="isEditable">
                    <button :title="translations['Remove product']" class="cc-control cc-control--close" @click="removeProduct">&times;</button>
                </div>
            </div>
            <div class="cc-product__information__main">
                <div class="cc-product__description">
                    <div class="cc-product__reference" v-if="product.reference">
                        <span class="cc-product__reference__label">{{ translations['Reference'] }}:</span>
                        <span class="cc-product__reference__value">{{ product.reference }}</span>
                    </div>
                </div>
                <div class="cc-product__order-information">
                    <div class="cc-product__availability">
                      <div v-if="product.availability_type === 'none'" class="cc-availability cc-availability-none">{{ translations['This product is no longer in stock'] }}</div>
                      <div v-if="product.availability_type === 'later' && product.available_later" class="cc-availability cc-availability-later">{{ product.available_later }}</div>
                      <div v-if="product.availability_type === 'now' && product.available_now" class="cc-availability cc-availability-now">{{ product.available_now }}</div>
                    </div>
                    <div class="cc-product__unit">
                        <span class="cc-price cc-price--original" v-if="discountExists">{{ product.formattedPrices.price_without_reduction_with_tax }} <span class="product-price-tax-title">({{ product.tax_name }})</span></span>
                        <span class="cc-price cc-price--reduced" v-if="discountExists">{{ product.formattedPrices.price_with_tax }} <span class="product-price-tax-title">({{ product.tax_name }})</span></span>
                        <span class="cc-price cc-price--common" v-if="!discountExists">{{ product.formattedPrices.price_with_tax }} <span class="product-price-tax-title">({{ product.tax_name }})</span></span>
                    </div>
                    <div class="cc-product__quantity">
                        <div class="cc-quantity cc-quantity--desktop" v-if="isEditable">
                            <input @change="setQuantity" type="text" name="quantity" class="cc-quantity__input" :placeholder="product.cart_quantity" />
                            <div class="cc-quantity__controls">
                                <div @click="increaseQuantity()" class="cc-quantity__control cc-quantity__control--plus">&plus;</div>
                                <div @click="decreaseQuantity()" class="cc-quantity__control cc-quantity__control--minus">&minus;</div>
                            </div>
                        </div>
                        <div class="cc-quantity cc-quantity--mobile" v-if="isEditable">
                            <div @click="decreaseQuantity()" class="cc-quantity__control cc-quantity__control--minus">&minus;</div>
                            <input @change="setQuantity" type="text" name="quantity" class="cc-quantity__input" :placeholder="product.cart_quantity" />
                            <div @click="increaseQuantity()" class="cc-quantity__control cc-quantity__control--plus">&plus;</div>
                        </div>
                        <div class="cc-product__quantity__text" v-if="!isEditable">{{ product.cart_quantity }}&nbsp;&times;</div>
                    </div>
                    <div class="cc-product__price">
                        <span class="cc-price cc-price--sum">{{ displayProductPrice }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                config: state => state.config,
            }),
            discountExists: function () {
                return this.product.price_without_reduction_with_tax !== this.product.price_with_tax;
            },
            displayProductPrice: function () {
                return this.product.is_gift ? this.translations['Free'] : this.product.formattedPrices.total_with_tax;
            },
        },
        methods: {
            removeProduct: function () {
                this.$store.dispatch('products/REMOVE', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                });
            },
            increaseQuantity: function () {
                this.$store.dispatch('products/INCREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                })
            },
            decreaseQuantity: function () {
                this.$store.dispatch('products/DECREASE_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute
                })
            },
            setQuantity: function (event) {
                const quantity = event.target.value;
                this.$store.dispatch('products/SET_QUANTITY', {
                    id: this.product.id,
                    id_attribute: this.product.id_attribute,
                    quantity: quantity,
                    cart_quantity: this.product.cart_quantity
                }).then(() => {
                    event.target.value = '';
                })
            }
        },
        name: 'Product',
        props: [
            'product',
            'isEditable',
        ],
    };
</script>


<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-product {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 1rem;
            border-width: 1px;
            border-style: solid;
            border-color: $border-color;

            & + .cc-product {
                margin-top: 1rem;
            }
        }

        .cc-product__image {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            width: 23%;
        }

        @include mobile {
            .cc-product__image {
                align-items: flex-start;
            }
        }

        .cc-product__image__thumbnail {
            display: block;
            max-width: 100%;
            max-height: 160px;
        }

        .cc-product__information {
            width: 77%;
        }

        .cc-product__information__header {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .cc-product__title {
            padding: 1rem;

            &:not(.cc-product__title--no-cotrols) {
                width: 90%;
            }

            &.cc-product__title--no-cotrols {
                width: 100%;
            }
        }

        @include mobile {
            .cc-product__title {
                &:not(.cc-product__title--no-cotrols) {
                    width: 80%;
                }
            }
        }

        .cc-product__title__link {
            font-size: 20px;
            font-weight: bold;
            color: $dark-grey;
        }

        .cc-product__controls {
            width: 10%;
            padding: 1rem;
            text-align: right;
        }

        @include mobile {
            .cc-product__controls {
                width: 20%;
            }
        }

        .cc-product__information__main {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .cc-product__description {
            width: 100%;
        }

        .cc-product__reference {
            padding: 1rem;
            text-transform: uppercase;
        }

        .cc-product__reference__label {
            display: inline-block;
        }

        .cc-product__reference__value {
            display: inline-block;
            margin-left: 0.5rem;
        }

        .cc-product__order-information {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            padding: 1rem;
        }

        @include mobile {
            .cc-product__order-information {
                padding: 0;
            }
        }

        .cc-product__availability {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            width: 40%;

            &.on-stock, &.supplier, .cc-availability-now {
                color: $green;
            }

            &.out-of-stock, .cc-availability-later {
                color: $orange;
            }

            &.out-of-stock, .cc-availability-none {
                color: $red;
            }
        }

        @include mobile {
            .cc-product__availability {
                order: 1;
                width: 100%;
                padding: 1rem;
            }
        }

        .cc-product__unit {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-end;
            width: 25%;
        }

        @include mobile {
            .cc-product__unit {
                justify-content: flex-end;
                order: 3;
                width: 50%;
                padding: 1rem;
            }
        }

        .cc-price {
            &.cc-price--original {
                font-size: 16px;
            }

            &.cc-price--reduced {
                font-size: 16px;
                margin-left: 1rem;
            }

            &.cc-price--common {
                font-size: 16px;
            }

            &.cc-price--sum {
                font-size: 18px;
            }
        }

        @include mobile {
            .cc-price {
                &.cc-price--original {
                    display: block;
                    width: 100%;
                    text-align: right;
                }

                &.cc-price--reduced {
                    display: block;
                    width: 100%;
                    margin-left: 0;
                    text-align: right;
                }

                &.cc-price--common {
                    display: block;
                    width: 100%;
                    text-align: right;
                }
            }
        }

        .cc-product__quantity {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-end;
            width: 20%;
        }

        @include mobile {
            .cc-product__quantity {
                justify-content: flex-start;
                order: 2;
                width: 50%;
                padding: 1rem;
            }
        }

        .cc-product__quantity__text {
            font-size: 18px;
            font-weight: bold;
        }

        .cc-product__price {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-end;
            width: 15%;
        }

        @include mobile {
            .cc-product__price {
                order: 4;
                width: 100%;
                padding: 1rem;
            }
        }
    }
</style>
